import academias from "../../assets/icons/academias.svg";
import saude from "../../assets/icons/hospitais.svg";
import educacao from "./assets/icons/escola.svg";
import gastronomia from "./assets/icons/gastronomia2.svg";
import conveniencia from "./assets/icons/conveniencia.svg";
import areaverde from "./assets/icons/areaverde.svg";
import lazer from "./assets/icons/shoppings.svg";
import estacoes from "./assets/icons/onibus.svg";
import bairro from "./assets/icons/turismo.svg";
import locais from "./assets/icons/servicos.svg";

const icons = {
  academias,
  educacao,
  gastronomia,
  saude,
  conveniencia,
  areaverde,
  lazer,
  estacoes,
  bairro,
  locais,
};

export const getIconInline = Object.fromEntries(
  Object.entries(icons).map(([key, src]) => [key, <img src={src} alt="" />])
);

export const getIcon = icons;
